import * as _ from 'lodash';
import type { VoidFunctionComponent } from 'react';

import { getQualityFilterVersionString } from '../../../helpers/policies';
import Button from '../../generic/Button';
import type { QualityRule } from '../../../types';

type ComponentFilterTableProps = {
  rules: Array<Partial<QualityRule>>;
  onAddRule: () => void;
  removeRule: (index: number) => void;
};

const ComponentFilterTable: VoidFunctionComponent<
  ComponentFilterTableProps
> = ({ rules, onAddRule, removeRule }) => (
  <>
    <div className="card">
      {rules.length === 0 ? (
        <div className="fossa-font-size-md italic">
          No rules to display.
        </div>
      ) : (
        <table className="quality-filter-table table table-min">
          <thead>
            <th>Package Name</th>
            <th>Version(s)</th>
          </thead>
          <tbody>
            {rules.map((rule, i) => (
              <tr key={rule.ruleId}>
                <td>{rule.dependencyFilterName || rule.packageProjectLocator}</td>
                <td>
                  {getQualityFilterVersionString(
                    rule.dependencyFilterVersionType,
                    rule.dependencyFilterStartVersion,
                    rule.dependencyFilterEndVersion,
                  )}
                </td>
                <td>
                  <Button
                    size="micro"
                    type="error"
                    onClick={_.partial(removeRule, i)}
                  >
                    Remove
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
    <Button
      size="medium"
      type="secondary"
      onClick={onAddRule}
      isFullWidth
    >
      Add rule
    </Button>
  </>
);

export default ComponentFilterTable;
